import type { UserRole } from "modules/auth/types";

export function getRoleHomePath(role: UserRole): string {
  switch (role) {
    case "emissor":
      return "/portal/emissor/ativos";
    case "devedor":
      return "/portal/devedor/emissoes";
    case "investidor":
      return "/titulos-divida";
    default:
      return "/";
  }
}
